<template>
  <v-text-field
    v-model="httpValue"
    :label="label"
    :rules="urlRules"
    :hint="hint"
    class="ma-2"
    @input="emit"
  ></v-text-field>
</template>

<script>
export default {
  // par defaut, quand on utilise v-model, la valeur recuperee
  // est "value" et l evenement ecoute est "input"
  // Je surcharge l'event ecouté ("change" au lieu de "input")
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      default: 'URL',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    hint: {
      default: '',
      type: String,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      httpValue: this.value,
      urlRules: [
        u => this.required === false || (!!u && this.required === true) || 'Required field',
        u => {
          const pattern = /^(http[^\s]+)*$/;
          return (
            pattern.test(u) || 'Invalid URL. Should starts by string "http", space not allowed'
          );
        },
      ],
    };
  },
  watch: {
    value(v) {
      this.httpValue = v;
    },
  },
  methods: {
    emit() {
      this.$emit('change', this.httpValue);
    },
  },
};
</script>
